import Button from '@admin/components/button'
import Token from '@admin/components/token'
import List from '@admin/components/list'
import PropTypes from 'prop-types'
import React from 'react'
import User from './user'

class UserField extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.array,
    required: PropTypes.bool,
    users: PropTypes.array,
    onChange: PropTypes.func,
    onReady: PropTypes.func,
    onValid: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    users: []
  }

  _handleAdd = this._handleAdd.bind(this)
  _handleCreate = this._handleCreate.bind(this)
  _handleValidate = this._handleValidate.bind(this)

  render() {
    return (
      <>
        <List { ...this._getList() } />
        <Button { ...this._getAdd() } />
      </>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(defaultValue) this.setState({
      users: defaultValue
    })
    this.props.onReady(this._handleValidate)
  }

  componentDidUpdate(prevProps, prevState) {
    const { users } = this.state
    if(!_.isEqual(users, prevState.users)) {
      this.props.onChange(users)
    }
  }

  _getAdd() {
    return {
      label: '+ t(add recipient)',
      className: 'link',
      handler: this._handleAdd
    }
  }

  _getEdit(index) {
    const user = this.state.users[index]
    return {
      user,
      mode: 'edit',
      onDone: this._handleUpdate.bind(this, index)
    }
  }

  _getList() {
    const users = this._getUsers()
    return {
      actions: (item, index) => [
        {
          svg: 'pencil',
          handler: this._handleEdit.bind(this, index)
        },
        {
          svg: 'x',
          confirm: 't(Are you sure you want to remove this recipient?)',
          handler: this._handleRemove.bind(this, index)
        }
      ],
      items: users,
      empty: <Token text='t(You have not yet added any recipients)' />,
      format: (user) => (
        <Token>
          <span className="crm-recipientsfield-recipient-extension">
            { user.last_name.toUpperCase().substr(0, 3) }
          </span>
          { user.full_name }
        </Token>
      )
    }
  }

  _getNew() {
    return {
      mode: 'new',
      onDone: this._handleCreate
    }
  }

  _getUser(id) {
    const { users } = this.props
    const user = _.find(users, { id })
    return user
  }

  _getUsers() {
    const { users } = this.state
    return users.map((user, index) => ({
      ...this._getUser(user.user_id),
      index
    })).sort((a,b) => {
      return a.last_name > b.last_name ? 1 : -1
    })
  }

  _handleAdd() {
    this.context.form.push(User, this._getNew())
  }

  _handleCreate(user) {
    const { users } = this.state
    this.setState({
      users: [
        ...users,
        user
      ]
    })
  }

  _handleEdit(index) {
    this.context.form.push(User, this._getEdit(index))
  }

  _handleRemove(index) {
    const { users } = this.state
    this.setState({
      users: users.filter((user, i) => {
        return i !== index
      })
    })
  }

  _handleUpdate(i, updated) {
    const { users } = this.state
    this.setState({
      users: users.map((user, index) => {
        return index === i ? updated : user
      })
    })
  }

  _handleValidate() {
    const { users } = this.state
    const { required, onValid } = this.props
    if(required && (!users || users.length === 0)) {
      return onValid(null, ['You must add at least 1 recipient'])
    }
    onValid(users)
  }

}

export default UserField
